<template>
  <div v-if="items.length" class="mt-10 mt-md-13 mt-lg-16">
    <TitleWidget>
      {{ title }}
    </TitleWidget>

    <div class="mt-6 mt-md-8 items">
      <template v-for="(item, keyItems) in items">
        <ProductCard
          v-if="(smOnly && keyItems < itemsPerPage - 1) || !smOnly"
          :key="keyItems"
          v-bind="item"
        ></ProductCard>
      </template>
    </div>
  </div>
</template>

<script>
import TitleWidget from "../../components/widgets/TitleWidget.vue";
import ProductCard from "../../components/cards/ProductCard.vue";
import { formatToURL } from "../../utils/formatToURL";
import { productFilter } from "../../utils/productFilter";

const _config = {
  mod: "products",
};

const _pagination = {
  itemsPerPage: 5,
};

const _data = {
  title: "Produtos Relacionados",
  ..._pagination,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    items() {
      return this.$rest(_config.mod)
        .list.filter(
          ({ id }, index) => +id !== +this.itemId && index < this.itemsPerPage
        )
        .map(({ id, img, title, category }) => ({
          img: img ? this.files + img : "",
          title,
          to: `/${formatToURL(category.title)}/${formatToURL(
            `${title}-${id}`
          )}`,
        }));
    },
    smOnly() {
      return this.$vuetify.breakpoint.smOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        itemsPerPage: this.itemsPerPage,
      };

      if (this.categoryId) params.category = this.categoryId;

      this.$rest(_config.mod)
        .get({ params })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    TitleWidget,
    ProductCard,
  },
  mixins: [productFilter],
};
</script>

<style lang="scss" scoped>
.items {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 1279.9px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 959.9px) {
    gap: 12px;
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
